import {StickerType, StringStickerState} from 'yougile-model'
import {ACustomStickerCtl} from './a-custom-sticker-ctl'

export class StringCtl extends ACustomStickerCtl<StringStickerState> {
  public get type(): StickerType {
    return 'string'
  }

  public makeNewState(): StringStickerState {
    return {
      id: this.makeShortId(),
      name: '',
      color: 'sticker-gray'
    }
  }
}
